import { canConnect } from '../../core';
import type { ConnectionMode, HandleRef } from '../../core';

const HANDLE_CLASS = 'cm-handle';

/** Reads which handle a DOM element is, or null for anything else. */
export const handleRefOf = (element: Element | null | undefined): HandleRef | null => {
  if (!(element instanceof HTMLElement) || !element.classList.contains(HANDLE_CLASS)) return null;
  const { nodeid, handleid } = element.dataset;
  if (!nodeid) return null;
  return { nodeId: nodeid, handleId: handleid ?? null, type: element.classList.contains('target') ? 'target' : 'source' };
};

/** The rendered element of a handle (like v11, connectability is read from its classes). */
export const findHandleElement = (doc: Document, { nodeId, handleId, type }: HandleRef): HTMLElement | null =>
  Array.from(doc.querySelectorAll<HTMLElement>(`.${HANDLE_CLASS}.${type}`)).find(
    (element) => element.dataset.nodeid === nodeId && (element.dataset.handleid ?? null) === handleId,
  ) ?? null;

/** Whether a connection from `from` may end on `to`: `to` accepts connections and the v11 mode rule allows it. */
export const isValidEnd = (doc: Document, from: HandleRef, to: HandleRef, connectionMode: ConnectionMode): boolean => {
  const element = findHandleElement(doc, to);
  const acceptsEnd = Boolean(element?.classList.contains('connectable') && element.classList.contains('connectableend'));
  return acceptsEnd && canConnect(from, to, connectionMode);
};

/** The handle directly under the pointer, if any — it wins over the closest-distance handle (v11). */
export const handleUnderPointer = (doc: Document, { clientX, clientY }: MouseEvent): HandleRef | null =>
  handleRefOf(doc.elementsFromPoint(clientX, clientY).find((element) => element.classList.contains(HANDLE_CLASS)));
